export enum PULSE_ELEMENTS_CHUNK {
  CONTENT = 'content',
}
